module.exports = __webpack_public_path__ + "static/media/mtto_inocuidad.8694bd22.svg";